const featureSwitch = {
  jpLang: process.env.NEXT_PUBLIC_JP_LANG === "true",
  newProductPages: process.env.NEXT_PUBLIC_NEW_PRODUCT_PAGES === "true"
}

export default featureSwitch
